module.exports = __webpack_public_path__ + "img/MX-5210.001652ff.jpg";